import { gql } from '@apollo/client';
import { ORGANIZATION_DETAIL_FIELDS } from '../../fragments';
import { ApolloClientFunctionProps } from '../../utils';
import { OrganizationType } from '../../../types';
import { GetOrganizationByIdProps } from './organization.types';

export const GET_ORGANIZATIONS = gql`
  ${ORGANIZATION_DETAIL_FIELDS}
  query GetOrganizations {
    organizations {
      ...OrganizationDetailFields
    }
  }
`;

export function getOrganizations({ client }: ApolloClientFunctionProps) {
  return client?.watchQuery<{ organizations: OrganizationType[] }>({
    query: GET_ORGANIZATIONS,
  });
}

export const GET_ORGANIZATION_BY_ID = gql`
  ${ORGANIZATION_DETAIL_FIELDS}
  query GetOrganizationById($organizationId: ID!) {
    organization(organizationId: $organizationId) {
      ...OrganizationDetailFields
    }
  }
`;

export function getOrganizationById({ client, organizationId }: GetOrganizationByIdProps) {
  return client?.watchQuery<{ organizations: OrganizationType }>({
    query: GET_ORGANIZATION_BY_ID,
    variables: {
      organizationId,
    },
  });
}
